import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractParenthesis',
})
export class ExtractParenthesisPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    const start = value.indexOf('(');
    const end = value.lastIndexOf(')');

    if (start === -1 || end === -1 || end <= start) {
      return '';
    }

    const extracted = value.substring(start + 1, end).trim();

    if (extracted === '') {
      return '';
    }

    const firstLetter = extracted.charAt(0).toUpperCase();
    const rest = extracted.slice(1);

    return firstLetter + rest;
  }
}
